import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';

import { Button, Input } from '@xsolla/ui-core';
import { Search } from '@xsolla/ui-icons';

import { IGetParams } from '../../../hooks/types';
import { SelectSearchBy } from './SelectSearchBy';
import { FilterUserBlock } from './style';

type Props = {
  inputRef: React.RefObject<HTMLInputElement>;
  setParams: React.Dispatch<React.SetStateAction<IGetParams>>;
  setPage: (page: number) => void;
};

const SearchField = ({ inputRef, setParams, setPage }: Props): JSX.Element => {
  const [selectedSearchBy, setSelectedSearchBy] = useState<string>('');

  const intl = useIntl();

  const findUserHandle = useCallback(() => {
    if (inputRef.current && !inputRef.current.value) {
      setParams((prev) => ({
        ...prev,
        search_query: undefined,
        search_by: undefined
      }));
      return;
    }

    if (inputRef.current) {
      const currValue = inputRef.current?.value.trim();
      let searchBy = 'contact';

      if (new RegExp(/^.{8}-.{4}-.{4}-.{4}-.{12}$/).test(currValue)) {
        searchBy = 'id';
      }

      if (new RegExp(/^\+?\d{5,15}$/).test(currValue)) {
        searchBy = 'phone';
      }

      setPage(1);
      setParams((prev) => ({
        ...prev,
        offset: 0,
        search_query: inputRef.current?.value,
        search_by: selectedSearchBy || searchBy
      }));
    }
  }, [selectedSearchBy, inputRef]);

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === 'Enter') {
      findUserHandle();
    }
  };

  const onChangeSearchBy = (value: string) => {
    setSelectedSearchBy(value);
  };

  return (
    <>
      <FilterUserBlock>
        <SelectSearchBy value={selectedSearchBy} onChange={onChangeSearchBy} />
      </FilterUserBlock>
      <FilterUserBlock>
        <Input
          extraAlign="left"
          placeholder={intl.formatMessage({
            id: 'users.list-block.search-user.input-placeholder'
          })}
          extra={Search}
          ref={inputRef}
          uiSize="sm"
          onKeyPress={handleKeyPress}
          data-test-id="user-list-search-input"
        />
      </FilterUserBlock>
      <Button
        onClick={findUserHandle}
        look="default"
        palette="brand"
        size="sm"
        data-test-id="user-list-search-btn">
        {intl.messages['users.list-block.search-user.button']}
      </Button>
    </>
  );
};

export default SearchField;
